import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class ProfessionService {

  constructor(private _http: HttpClient) {
  }

  getListByCollegeId(collegeId?: number) {
    console.log('collegeId');
    console.log(collegeId);
    if (!collegeId) {
      collegeId = 0;
    }
    return this._http.get<any[]>(`api/a/dict/profession/list/by/college/${collegeId}`);
  }

  getAlternativeProfessionListByCode(collegeId: number, educatedId: number, year: number, centerProfessionId: number) {
    return this._http.get<any[]>(`api/a/dict/profession/list/by/college/${collegeId}/${educatedId}/${year}/${centerProfessionId}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/common_services/profession.service.ts